<template>
  <DeleteConfirmDialog
    v-model="showDeleteDialog"
    test-id-prefix="my-calendar.delete-task-dialog"
    title="Delete Task?"
    :loading="isLoading"
    :item-name="taskName"
    item-type="task"
    @confirm="handleDeleteConfirm"
    @update:modelValue="handleDialogClose"
  />
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import DeleteConfirmDialog from '@/views/my-workbench-new/archive/components/DeleteConfirmDialog.vue'

const emit = defineEmits(['close', 'delete'])
const { visible, taskName, deleteAction } = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  taskName: {
    type: String,
    default: ''
  },
  deleteAction: {
    type: Function,
    default: null
  }
})

const showDeleteDialog = ref(visible)
const isLoading = ref(false)

function handleDialogClose(value) {
  showDeleteDialog.value = value
  if (!value) {
    emit('close')
  }
}

async function handleDeleteConfirm() {
  if (deleteAction) {
    isLoading.value = true
    try {
      await deleteAction()
      emit('delete')
    } catch (error) {
      console.error('Error deleting task:', error)
    } finally {
      isLoading.value = false
    }
  } else {
    emit('delete')
  }
}

// Watch for prop changes
watch(() => visible, (newValue) => {
  showDeleteDialog.value = newValue
})
</script>


